// removed by extract-text-webpack-plugin
module.exports = {"linkEpicAccountBox":"_3QEuqz_orpPuZJB26lMSmV","linkEpicAccountBoxInner":"_2RF1pBdQaLIvzze-HBx4_Y","formFields":"_3QPMzvbRHTq1-REQqru6Qn","emailField":"GU7rXAE0KrnWqupbCY056","buttonsGroup":"_2t1x-4U0PIbzAygNZQmu-L","footer":"_3TZu0LZyisdKFjm5v4PhLC","error":"_3MYztPYN_oL7idtEQESDuX"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/LinkEpicAccountBox.scss
// module id = 2640
// module chunks = 0